import { SpaceBetween } from "@cloudscape-design/components-themed";

import SearchBar from "../components/users/SearchBar";
import Table from "../components/users/Table";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../app/hook";
import { stringToBoolean } from "../components/default-constants";
import {
  INITIAL_SEARCH_CRITERIA,
  setSearchCriteria,
} from "../features/slices/user-list";

const Users = (): JSX.Element => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.ACCOUNT);
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search);
  const isBackFromDetail = stringToBoolean(query.get("isBackFromDetail"));
  const [isSkipSearch, setIsSkipSearch] = useState(true);

  useEffect(() => {
    if (isBackFromDetail) {
      setIsSkipSearch(false);
    } else {
      dispatch(setSearchCriteria(INITIAL_SEARCH_CRITERIA));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <SpaceBetween size="l">
      <SearchBar setIsSkipSearch={setIsSkipSearch} />
      <Table isBackFromDetail={isBackFromDetail} isSkipSearch={isSkipSearch} />
    </SpaceBetween>
  );
};

export default Users;
